// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 40px;
  gap: 5px;
}

.glowing-line {
  width: 200px;
  height: 2px;
  background: linear-gradient(270deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #8f00ff);
  background-size: 1400% 1400%;
  border-radius: 2px;
  animation: glow 3s ease infinite, shimmer 8s linear infinite;
  position: relative;
  margin-bottom: 4px;
}

.glowing-line::before {
  content: "";
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
  bottom: -10px;
  filter: blur(10px);
  background: inherit;
  opacity: 0.5;
  pointer-events: none; /* Ensures the blur doesn't interfere with other elements */
}

.loader-text {
  font-family: Arial, sans-serif;
  font-size: 12px;
  letter-spacing: 1px;
  animation: textGlow 3s ease infinite;
  text-align: center;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.3); /* Subtle text glow */
  display: flex;
}

.brand {
  background: linear-gradient(90deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #8f00ff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  background-size: 400% 100%;
  animation: shimmer 8s linear infinite;
  font-weight: bold;
  margin: 0 4px;
}

@keyframes glow {
  0% {
    filter: brightness(100%);
  }
  50% {
    filter: brightness(150%);
  }
  100% {
    filter: brightness(100%);
  }
}
@keyframes shimmer {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 400% 50%;
  }
}
@keyframes textGlow {
  0% {
    opacity: 0.8;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.8;
  }
}
.ai-logo {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  position: absolute;
  bottom: 38px;
  right: 13px;
}`, "",{"version":3,"sources":["webpack://./src/app/common/shared-module/attender-ailoader/attender-ailoader.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,QAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,kGAAA;EASA,4BAAA;EACA,kBAAA;EACA,4DAAA;EAEA,kBAAA;EACA,kBAAA;AARF;;AAWA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA,EAAA,2DAAA;AARF;;AAWA;EACE,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,8CAAA,EAAA,qBAAA;EACA,aAAA;AARF;;AAWA;EACE,iGAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qCAAA;EACA,iBAAA;EACA,aAAA;AARF;;AAWA;EACE;IACE,wBAAA;EARF;EAUA;IACE,wBAAA;EARF;EAUA;IACE,wBAAA;EARF;AACF;AAWA;EACE;IACE,2BAAA;EATF;EAWA;IACE,6BAAA;EATF;AACF;AAYA;EACE;IACE,YAAA;EAVF;EAYA;IACE,UAAA;EAVF;EAYA;IACE,YAAA;EAVF;AACF;AAcA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACE,YAAA;EACA,WAAA;AAZJ","sourcesContent":[".loader-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 40px;\n  gap: 5px;\n}\n\n.glowing-line {\n  width: 200px;\n  height: 2px;\n  background: linear-gradient(270deg,\n    #ff0000,\n    #ff7f00,\n    #ffff00,\n    #00ff00,\n    #0000ff,\n    #4b0082,\n    #8f00ff\n  );\n  background-size: 1400% 1400%;\n  border-radius: 2px;\n  animation: glow 3s ease infinite,\n             shimmer 8s linear infinite;\n  position: relative;\n  margin-bottom: 4px;\n}\n\n.glowing-line::before {\n  content: '';\n  position: absolute;\n  top: -10px;\n  left: 0;\n  right: 0;\n  bottom: -10px;\n  filter: blur(10px);\n  background: inherit;\n  opacity: 0.5;\n  pointer-events: none; /* Ensures the blur doesn't interfere with other elements */\n}\n\n.loader-text {\n  font-family: Arial, sans-serif;\n  font-size: 12px;\n  letter-spacing: 1px;\n  animation: textGlow 3s ease infinite;\n  text-align: center;\n  text-shadow: 0 0 10px rgba(255, 255, 255, 0.3); /* Subtle text glow */\n  display: flex;\n}\n\n.brand {\n  background: linear-gradient(90deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #8f00ff);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n  background-size: 400% 100%;\n  animation: shimmer 8s linear infinite;\n  font-weight: bold;\n  margin: 0 4px;\n}\n\n@keyframes glow {\n  0% {\n    filter: brightness(100%);\n  }\n  50% {\n    filter: brightness(150%);\n  }\n  100% {\n    filter: brightness(100%);\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: 0% 50%;\n  }\n  100% {\n    background-position: 400% 50%;\n  }\n}\n\n@keyframes textGlow {\n  0% {\n    opacity: 0.8;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: 0.8;\n  }\n}\n\n\n.ai-logo {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  position: absolute;\n    bottom: 38px;\n    right: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
